import { render } from "./Tanda.vue?vue&type=template&id=6a9e0804"
import script from "./Tanda.vue?vue&type=script&lang=js"
export * from "./Tanda.vue?vue&type=script&lang=js"

import "./Tanda.vue?vue&type=style&index=0&id=6a9e0804&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__